export const shareTargets: ShareTarget[] = ["facebook", "pinterest", "twitter", "link"];

const facebookAppId = "258637720963039";
export const facebookBaseUrl = `https://www.facebook.com/dialog/feed?app_id=${facebookAppId}`;
export const pinterestBaseUrl = "https://www.pinterest.com/pin/create/button/";
export const twitterBaseUrl = "https://twitter.com/intent/tweet";

// Doesn't seem to be any public docs about their pin creation URL.
// Source code for their pinit.js https://github.com/pinterest/widgets/blob/78f5658a31130de7c317579ca7ca9cd6380e450d/pinit_main.js#L671
function pinterestUrl(shareUrl: string, imageUrl: string, caption?: string | null) {
  const url = new URL(pinterestBaseUrl);

  url.searchParams.set("media", imageUrl);
  url.searchParams.set("url", shareUrl);

  if (caption) {
    url.searchParams.set("description", caption);
  }

  return url.toString();
}

// https://developer.twitter.com/en/docs/twitter-for-websites/tweet-button/overview
function twitterUrl(shareUrl: string) {
  const url = new URL(twitterBaseUrl);

  url.searchParams.set("hashtags", "liketkit");
  url.searchParams.set("text", "@liketoknowit");
  url.searchParams.set("url", shareUrl);

  return url.toString();
}

// https://developers.facebook.com/docs/sharing/reference/feed-dialog
function facebookUrl(shareUrl: string, picture: string, description?: string | null) {
  const url = new URL(facebookBaseUrl);

  url.searchParams.set("link", shareUrl);
  url.searchParams.set("picture", picture);

  if (description) {
    url.searchParams.set("description", description);
  }

  return url.toString();
}

export function getLinks({
  shareUrl,
  imageUrl,
  caption,
}: {
  // Image to be attached to the shared media. e.g. a post hero image, an avatar, or a collection image
  imageUrl: string;
  // URL to overrides the current page url. Useful for sharing shortened share urls or branch links
  shareUrl: string;
  // A short caption to accompany the shared post, such as a post caption or a collection title
  caption?: string | null;
}) {
  const socialLinks = {
    pinterest: pinterestUrl(shareUrl, imageUrl, caption),
    twitter: twitterUrl(shareUrl),
    facebook: facebookUrl(shareUrl, imageUrl, caption),
    link: shareUrl,
  };

  return socialLinks;
}
